import { useCheckPermissions } from '@/shared';
import { SaveCategoryProduct } from '../../shared/components/saveCategoryProduct';
import { PermissionsEnum } from '@/auth/interfaces';

export interface CreateCategoryProductPageInterface {}

const CreateCategoryProductPage: React.FC<CreateCategoryProductPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_add_categoria_producto)
  return <SaveCategoryProduct titlePage="Crear Categoria producto" />;
};

export default CreateCategoryProductPage;
